import { render, staticRenderFns } from "./CreateThreadColorsForm.vue?vue&type=template&id=203fbeff&"
import script from "./CreateThreadColorsForm.vue?vue&type=script&lang=js&"
export * from "./CreateThreadColorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports